// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyAPDo2xlej3tHq1tnzE0ZcPKgLUU__UcEg",
    authDomain: "ancytree-test.firebaseapp.com",
    projectId: "ancytree-test",
    storageBucket: "ancytree-test.appspot.com",
    messagingSenderId: "633472042617",
    appId: "1:633472042617:web:7ecde6d9fb87e0603fb6a8",
    databaseURL: 'https://ancytree-test.firebaseio.com',
  },
  apiUrl: 'https://betaapi.ancytree.com/api',
  api_url: "https://betaorderapi.ancytree.com/api/"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
